import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { useBrand } from '~/modules/branding';
import { ErrorBoundary } from '~/modules/errors/components/ErrorBoundary';

import { useRemotes } from '../hooks/useRemotes';

function RemotesStatus() {
  const { t } = useTranslation('remotes');
  const { name } = useBrand();
  const { remotes } = useRemotes();

  return (
    <section>
      <Helmet>
        <title>{t('pageTitle')}</title>
      </Helmet>
      <h1>{t('header')}</h1>
      <table>
        <thead>
          <tr>
            <th>{t('tableHeaders.remoteApp')}</th>
            <th>{t('tableHeaders.status')}</th>
          </tr>
        </thead>
        <tbody>
          {remotes
            .filter((remote) => remote.brands.includes(name))
            .map((remote) => (
              <tr key={remote.name}>
                <td>{remote.name}</td>
                <td>
                  <ErrorBoundary
                    fallback={
                      <span className="rounded bg-error-default">
                        {t('statuses.down')}
                      </span>
                    }
                  >
                    <Suspense>
                      <span className="rounded bg-success-default">
                        {t('statuses.operational')}
                      </span>
                      <remote.status />
                    </Suspense>
                  </ErrorBoundary>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </section>
  );
}

RemotesStatus.displayName = 'RemotesStatus';

export { RemotesStatus };
